// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1__AT","content":"styles_content__3-5VL"};